import { Component, EventEmitter, Injector, OnInit, Output } from '@angular/core';
import { finalize } from '@node_modules/rxjs/operators';
import { AppComponentBase } from '@shared/app-component-base';
import { AnexarExameDto, ConsultaDto, ConsultaServiceProxy, SelectItemDto } from '@shared/service-proxies/service-proxies';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-anexar-exame',
  templateUrl: './anexar-exame.component.html',
  styleUrls: ['./anexar-exame.component.scss']
})
export class AnexarExameComponent extends AppComponentBase implements OnInit{
  protected saving: boolean = false;
  protected exame: AnexarExameDto = undefined;
  protected solicitacaoId: string = undefined;
  protected pedidos: SelectItemDto[] = [];
  public consulta: ConsultaDto;
  @Output() onSave = new EventEmitter<any>();

  constructor(
    injector: Injector,
    private readonly bsModalRef: BsModalRef,
    private readonly _consultaService: ConsultaServiceProxy,
  ) {
    super(injector)
  }

  ngOnInit(): void {
    this.pedidos = this.consulta.pedidos.filter(x => !x.dataEnvio).map(x => new SelectItemDto({
      descricao: x.nome,
      id: x.id,
    }))
  }

  handleUpload(event) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];

    this.exame = new AnexarExameDto();
    this.exame.consultaId = this.consulta.id;
    this.exame.fileNameWithOutExtension = file.name;
    this.exame.tipoArquivo = file.type;
    this.exame.tamanhoArquivo = file.size;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.exame.base64File = reader.result.toString();
    };
  }


  save(): void {
    if (!this.exame) {
      return;
    }

    if (this.exame.base64File) {
      if (this.exame.tipoArquivo != '') {
        const splitFile = this.exame.fileNameWithOutExtension.split('.');
        this.exame.extension = splitFile[splitFile.length - 1];
        splitFile.pop();
        this.exame.fileNameWithOutExtension = splitFile.join('.');
      }

      this.saving = true;
      this.exame.solicitacaoId = this.solicitacaoId;
      abp.ui.setBusy();
      this._consultaService
        .anexarExame(this.exame)
        .pipe(
          finalize(() => {
            abp.ui.clearBusy();
          })
        )
        .subscribe((x) => {
          this.notify.info("Exame anexada com sucesso");
          this.bsModalRef.hide();
          this.onSave.emit();
        });
    }
  }
}
